import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';
import { getTeamActivityData } from './Teams';

export const getActivityStream = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/activitystream`;
    const url = buildQueryString(rest, baseUrl);

    return VerbFetch(url);
};

export const postComment = (params) => {
    const { body, pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/comments`;
    const options = {
        method: 'POST',
        body
    };
    return VerbFetch(baseUrl, options);
};

export const putComment = (params, getParams, secondTry = false) => {
    const { commentId, body, pathsContext } = params;
    const baseUrl = `${pathsContext.serverUrl}/activitystream/${commentId}`;
    const options = {
        method: 'PUT',
        body
    };
    return VerbFetch(baseUrl, options).catch((err) => {
        if (err.status === 409 && !secondTry) {
            return getTeamActivityData({...getParams, pathsContext}).then((retrievedActivity) => {
                const retrievedComment = retrievedActivity.find((activity) => activity._id === commentId);
                const newBodyToSend = {
                    ...body,
                    revision: retrievedComment.revision
                };
                return putComment({ commentId, body: newBodyToSend, pathsContext }, getParams, true);
            });
        }
        return null;
    });
};

export const getCommentThreadActivity = (params) => {
    const { parentId, parentType, pathsContext } = params;
    const uri = `${pathsContext.serverUrl}/comments/${parentId}/replythread?parentId=${parentId}&parentType=${parentType}`;
    return VerbFetch(uri);
};
